const COMMON_STYLES = {
  "Progressbar.Bar.Height": {
    defaultValue: "10px"
  },
  "Progressbar.Small.Bar.Height": {
    defaultValue: "4px"
  },
  "Progressbar.Medium.Bar.Height": {
    defaultValue: "10px"
  },
  "Progressbar.Large.Bar.Height": {
    defaultValue: "20px"
  },
  "Progressbar.Bar.Linecap": {
    defaultValue: "round"
  },
  "Progressbar.Bar.Border.Top.Left.Radius": {
    defaultValue: "10px"
  },
  "Progressbar.Bar.Border.Top.Right.Radius": {
    defaultValue: "10px"
  },
  "Progressbar.Bar.Border.Bottom.Left.Radius": {
    defaultValue: "10px"
  },
  "Progressbar.Bar.Border.Bottom.Right.Radius": {
    defaultValue: "10px"
  },

  "Progressbar.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Progressbar.Bar.Color": {
    ref: "Color.Gray.300"
  },

  "Progressbar.Label.Color": {
    ref: "Color.Black"
  },
  "Progressbar.Label.Font.Size": {
    ref: "Font.Size.14"
  },

  "Progressbar.Label.Font.Weight": {
    ref: "Font.Weight.Regular"
  },

  "Progressbar.HelpText.Color": {
    ref: "Color.Gray.600"
  },
  "Progressbar.HelpText.Font.Size": {
    ref: "Font.Size.12"
  },

  "Progressbar.HelpText.Font.Weight": {
    ref: "Font.Weight.Regular"
  },

  "Progressbar.Value.Color": {
    ref: "Color.Black"
  },
  "Progressbar.Value.Font.Weight": {
    ref: "Font.Weight.Regular"
  },

  // border

  "Progressbar.Border.Color": {
    ref: "Color.Black"
  },
  "Progressbar.Border.Style": {
    defaultValue: "solid"
  },
  "Progressbar.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Progressbar.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },

  // padding

  "Progressbar.Padding.Top": {
    defaultValue: "0px"
  },
  "Progressbar.Padding.Right": {
    defaultValue: "0px"
  },
  "Progressbar.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Progressbar.Padding.Left": {
    defaultValue: "0px"
  },
  "Progressbar.Height": {
    defaultValue: "auto"
  },

  //Margin

  "Progressbar.Margin.Top": {
    defaultValue: "0px"
  },
  "Progressbar.Margin.Right": {
    defaultValue: "0px"
  },
  "Progressbar.Margin.Left": {
    defaultValue: "0px"
  },
  "Progressbar.Margin.Bottom": {
    defaultValue: "0px"
  },

  // box shadow

  "Progressbar.Shadow.Type": {
    defaultValue: "none"
  },
  "Progressbar.Shadow.Color": {
    ref: "Color.Shadow"
  },

  //box modal

  "Progressbar.Box.Sizing": {
    defaultValue: "border-box"
  },

  //cursor

  "Progressbar.Cursor": {
    defaultValue: "pointer"
  }
};

const LINEAR_PROGRESS_BAR = {
  "Progressbar.Linear.Bar.Fill.Color": {
    ref: "Color.Secondary.One.500"
  },
  "Progressbar.Linear.Width": {
    defaultValue: "100%"
  },
  "Progressbar.Linear.Min.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Linear.Max.Width": {
    defaultValue: "unset"
  },
  "Progressbar.Linear.Height": {
    defaultValue: "auto"
  },
  "Progressbar.Linear.Min.Height": {
    defaultValue: "unset"
  },
  "Progressbar.Linear.Max.Height": {
    defaultValue: "unset"
  },

  //percentage value

  "Progressbar.Linear.Value.Font.Size": {
    ref: "Font.Size.14"
  }
};

const CIRCULAR_PROGRESS_BAR = {
  "Progressbar.Circular.Bar.Fill.Color": {
    ref: "Color.Primary.500"
  },
  "Progressbar.Circular.Width": {
    defaultValue: "200px"
  },
  "Progressbar.Circular.Min.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Circular.Max.Width": {
    defaultValue: "unset"
  },
  "Progressbar.Circular.Height": {
    defaultValue: "auto"
  },
  "Progressbar.Circular.Min.Height": {
    defaultValue: "unset"
  },
  "Progressbar.Circular.Max.Height": {
    defaultValue: "unset"
  },

  //percentage value

  "Progressbar.Circular.Value.Font.Size": {
    ref: "Font.Size.32"
  }
};

const SEMI_CIRCULAR_PROGRESS_BAR = {
  "Progressbar.Semicircular.Bar.Fill.Color": {
    ref: "Color.Primary.500"
  },
  "Progressbar.Semicircular.Width": {
    defaultValue: "200px"
  },
  "Progressbar.Semicircular.Min.Width": {
    defaultValue: "0px"
  },
  "Progressbar.Semicircular.Max.Width": {
    defaultValue: "unset"
  },
  "Progressbar.Semicircular.Height": {
    defaultValue: "auto"
  },
  "Progressbar.Semicircular.Min.Height": {
    defaultValue: "unset"
  },
  "Progressbar.Semicircular.Max.Height": {
    defaultValue: "unset"
  },

  //percentage value

  "Progressbar.Semicircular.Value.Font.Size": {
    ref: "Font.Size.28"
  }
};

export const APP_PROGRESSBAR = {
  ...COMMON_STYLES,
  ...LINEAR_PROGRESS_BAR,
  ...CIRCULAR_PROGRESS_BAR,
  ...SEMI_CIRCULAR_PROGRESS_BAR
};
